import { BitfFormItem } from '../bitf-form-item.model';

export class BitfStrapiFormItemConfig {
  [key: string]: BitfFormItem;

  constructor(data: any = {}) {
    if (data.attributes) {
      Object.keys(data.attributes).forEach(key => {
        this[key] = new BitfFormItem(data.attributes[key]);
      });
    }
  }
}
